// extracted by mini-css-extract-plugin
module.exports = {"showAnnouncement":"styles-module--show-announcement--1T5Hd"};